"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react/jsx-runtime"),
    t = require("react"),
    _o = function o() {
  return _o = Object.assign || function (e) {
    for (var t, o = 1, n = arguments.length; o < n; o++) {
      for (var i in t = arguments[o]) {
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      }
    }

    return e;
  }, _o.apply(this, arguments);
};

function n(e, t, o) {
  if (o || 2 === arguments.length) for (var n, i = 0, r = t.length; i < r; i++) {
    !n && i in t || (n || (n = Array.prototype.slice.call(t, 0, i)), n[i] = t[i]);
  }
  return e.concat(n || Array.prototype.slice.call(t));
}

function i(t) {
  var n = t.size,
      i = void 0 === n ? 25 : n,
      r = t.SVGstrokeColor,
      l = void 0 === r ? "currentColor" : r,
      a = t.SVGstorkeWidth,
      s = void 0 === a ? 0 : a,
      c = t.SVGclassName,
      d = void 0 === c ? "star-svg" : c,
      u = t.SVGstyle;
  return e.jsx("svg", _o({
    className: d,
    style: u,
    stroke: l,
    fill: "currentColor",
    strokeWidth: s,
    viewBox: "0 0 24 24",
    width: i,
    height: i,
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: e.jsx("path", {
      d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
    })
  }));
}

function r(e, t) {
  switch (t.type) {
    case "PointerMove":
      return _o(_o({}, e), {
        hoverValue: t.payload,
        hoverIndex: t.index
      });

    case "PointerLeave":
      return _o(_o({}, e), {
        ratingValue: e.ratingValue,
        hoverIndex: 0,
        hoverValue: null
      });

    case "MouseClick":
      return _o(_o({}, e), {
        valueIndex: e.hoverIndex,
        ratingValue: t.payload
      });

    default:
      return e;
  }
}

var l = "style-module_starRatingWrap__q-lJC",
    a = "style-module_simpleStarRating__nWUxf",
    s = "style-module_fillIcons__6---A",
    c = "style-module_emptyIcons__Bg-FZ",
    d = "style-module_tooltip__tKc3i";

function u() {
  return "undefined" != typeof window && window.matchMedia("(pointer: coarse)").matches || "ontouchstart" in window || "undefined" != typeof navigator && navigator.maxTouchPoints > 0;
}

!function (e, t) {
  void 0 === t && (t = {});
  var o = t.insertAt;

  if (e && "undefined" != typeof document) {
    var n = document.head || document.getElementsByTagName("head")[0],
        i = document.createElement("style");
    i.type = "text/css", "top" === o && n.firstChild ? n.insertBefore(i, n.firstChild) : n.appendChild(i), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e));
  }
}(".style-module_starRatingWrap__q-lJC{display:inline-block;touch-action:none}.style-module_simpleStarRating__nWUxf{display:inline-block;overflow:hidden;position:relative;touch-action:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle;white-space:nowrap}.style-module_fillIcons__6---A{display:inline-block;overflow:hidden;position:absolute;top:0;white-space:nowrap}.style-module_emptyIcons__Bg-FZ{display:inline-block}.style-module_tooltip__tKc3i{background-color:#333;border-radius:5px;color:#fff;display:inline-block;padding:5px 15px;vertical-align:middle}"), exports.Rating = function (v) {
  var p,
      f,
      h = v.onClick,
      y = v.onPointerMove,
      m = v.onPointerEnter,
      g = v.onPointerLeave,
      x = v.initialValue,
      _ = void 0 === x ? 0 : x,
      C = v.iconsCount,
      w = void 0 === C ? 5 : C,
      V = v.size,
      k = void 0 === V ? 40 : V,
      S = v.readonly,
      b = void 0 !== S && S,
      M = v.rtl,
      G = void 0 !== M && M,
      I = v.customIcons,
      N = void 0 === I ? [] : I,
      j = v.allowFraction,
      P = void 0 !== j && j,
      A = v.style,
      L = v.className,
      R = void 0 === L ? "react-simple-star-rating" : L,
      T = v.transition,
      W = void 0 !== T && T,
      z = v.allowHover,
      B = void 0 === z || z,
      E = v.disableFillHover,
      F = void 0 !== E && E,
      q = v.fillIcon,
      O = void 0 === q ? null : q,
      H = v.fillColor,
      J = void 0 === H ? "#ffbc0b" : H,
      K = v.fillColorArray,
      U = void 0 === K ? [] : K,
      Z = v.fillStyle,
      D = v.fillClassName,
      X = void 0 === D ? "filled-icons" : D,
      Y = v.emptyIcon,
      Q = void 0 === Y ? null : Y,
      $ = v.emptyColor,
      ee = void 0 === $ ? "#cccccc" : $,
      te = v.emptyStyle,
      oe = v.emptyClassName,
      ne = void 0 === oe ? "empty-icons" : oe,
      ie = v.allowTitleTag,
      re = void 0 === ie || ie,
      le = v.showTooltip,
      ae = void 0 !== le && le,
      se = v.tooltipDefaultText,
      ce = void 0 === se ? "Your Rate" : se,
      de = v.tooltipArray,
      ue = void 0 === de ? [] : de,
      ve = v.tooltipStyle,
      pe = v.tooltipClassName,
      fe = void 0 === pe ? "react-simple-star-rating-tooltip" : pe,
      he = v.SVGclassName,
      ye = void 0 === he ? "star-svg" : he,
      me = v.titleSeparator,
      ge = void 0 === me ? "out of" : me,
      xe = v.SVGstyle,
      _e = v.SVGstorkeWidth,
      Ce = void 0 === _e ? 0 : _e,
      we = v.SVGstrokeColor,
      Ve = void 0 === we ? "currentColor" : we,
      ke = t.useReducer(r, {
    hoverIndex: 0,
    valueIndex: 0,
    ratingValue: _,
    hoverValue: null
  }),
      Se = ke[0],
      be = Se.ratingValue,
      Me = Se.hoverValue,
      Ge = Se.hoverIndex,
      Ie = Se.valueIndex,
      Ne = ke[1];

  t.useEffect(function () {
    _ && Ne({
      type: "MouseClick",
      payload: 0
    });
  }, [_]);

  var je = t.useMemo(function () {
    return P ? 2 * w : w;
  }, [P, w]),
      Pe = t.useMemo(function () {
    return _ > je ? 0 : P || Math.floor(_) === _ ? Math.round(_ / w * 100) : 2 * Math.ceil(_) * 10;
  }, [P, _, w, je]),
      Ae = t.useMemo(function () {
    return (P ? 2 * _ - 1 : _ - 1) || 0;
  }, [P, _]),
      Le = t.useCallback(function (e) {
    return w % 2 != 0 ? e / 2 / 10 : e * w / 100;
  }, [w]),
      Re = function Re(e) {
    for (var t = e.clientX, o = e.currentTarget.children[0].getBoundingClientRect(), n = o.left, i = o.right, r = o.width, l = G ? i - t : t - n, a = je, s = Math.round(r / je), c = 0; c <= je; c += 1) {
      if (l <= s * c) {
        a = 0 === c && l < s ? 0 : c;
        break;
      }
    }

    var d = a - 1;
    a > 0 && (Ne({
      type: "PointerMove",
      payload: 100 * a / je,
      index: d
    }), y && Me && y(Le(Me), d, e));
  },
      Te = function Te(e) {
    Me && (Ne({
      type: "MouseClick",
      payload: Me
    }), h && h(Le(Me), Ge, e));
  },
      We = t.useMemo(function () {
    if (B) {
      if (F) {
        var e = be && be || Pe;
        return Me && Me > e ? Me : e;
      }

      return Me && Me || be && be || Pe;
    }

    return be && be || Pe;
  }, [B, F, Me, be, Pe]);

  t.useEffect(function () {
    ue.length > je && console.error("tooltipArray Array length is bigger then Icons Count length.");
  }, [ue.length, je]);
  var ze = t.useCallback(function (e) {
    return Me && e[Ge] || be && e[Ie] || _ && e[Ae];
  }, [Me, Ge, be, Ie, _, Ae]),
      Be = t.useMemo(function () {
    return Me && Le(Me) || be && Le(be) || _ && Le(Pe);
  }, [Me, Le, be, _, Pe]);
  return e.jsxs("span", _o({
    className: l,
    style: {
      direction: "".concat(G ? "rtl" : "ltr")
    }
  }, {
    children: [e.jsxs("span", _o({
      className: "".concat(a, " ").concat(R),
      style: _o({
        cursor: b ? "" : "pointer"
      }, A),
      onPointerMove: b ? void 0 : Re,
      onPointerEnter: b ? void 0 : function (e) {
        m && m(e), u() && Re(e);
      },
      onPointerLeave: b ? void 0 : function (e) {
        u() && Te(), Ne({
          type: "PointerLeave"
        }), g && g(e);
      },
      onClick: b ? void 0 : Te,
      "aria-hidden": "true"
    }, {
      children: [e.jsx("span", _o({
        className: "".concat(c, " ").concat(ne),
        style: _o({
          color: ee
        }, te)
      }, {
        children: n([], Array(w), !0).map(function (o, n) {
          var r;
          return e.jsx(t.Fragment, {
            children: (null === (r = N[n]) || void 0 === r ? void 0 : r.icon) || Q || e.jsx(i, {
              SVGclassName: ye,
              SVGstyle: xe,
              SVGstorkeWidth: Ce,
              SVGstrokeColor: Ve,
              size: k
            })
          }, n);
        })
      })), e.jsx("span", _o({
        className: "".concat(s, " ").concat(X),
        style: _o((p = {}, p[G ? "right" : "left"] = 0, p.color = ze(U) || J, p.transition = W ? "width .2s ease, color .2s ease" : "", p.width = "".concat(We, "%"), p), Z),
        title: re ? "".concat(Be, " ").concat(ge, " ").concat(w) : void 0
      }, {
        children: n([], Array(w), !0).map(function (o, n) {
          var r;
          return e.jsx(t.Fragment, {
            children: (null === (r = N[n]) || void 0 === r ? void 0 : r.icon) || O || e.jsx(i, {
              SVGclassName: ye,
              SVGstyle: xe,
              SVGstorkeWidth: Ce,
              SVGstrokeColor: Ve,
              size: k
            })
          }, n);
        })
      }))]
    })), ae && e.jsx("span", _o({
      className: "".concat(d, " ").concat(fe),
      style: _o((f = {}, f[G ? "marginRight" : "marginLeft"] = 20, f), ve)
    }, {
      children: (ue.length > 0 ? ze(ue) : Be) || ce
    }))]
  }));
};